import React from 'react'
import FormRegister from '@/components/FormRegister'
import NavBar from '@/components/NavBar'

const RegisterPage = () => {
  return (
    <>
      <NavBar />
      <FormRegister />
    </>
  )
}

export default RegisterPage
